import VendorParagraph from './VendorParagraph'

export default VendorParagraph
